import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftTank,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
} from "../../../components";
import routes from "../../../utils/cftRoutes";
import { useCft } from "../../../utils/CftProvider";
import IrrigationWaterFootprintForm, {
  IrrigationWaterFootprintFormContext,
} from "../../../forms/farmlands/waterFootprint/IrrigationWaterFootprintForm/IrrigationWaterFootprint.form";

function IrrigationWaterFootprintPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveWaterFootprint, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={66}
          cropName={meta.title.waterFootprint}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="waterFootprint" />

              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveWaterFootprint({
                    irrigation: values,
                  });
                  history.push(routes.FARMLANDS.WATER_FOOTPRINT.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:irrigationWaterFootprint.title", "Irygacja")}
          onBack={() => history.push(routes.FARMLANDS.WATER_FOOTPRINT.SOIL)}
          onNext={submitForm}
          nextText={t("cft:report.btn")}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:irrigationWaterFootprint.title", "Irygacja")}</h3>
            <p>
              {t(
                "cft:irrigationWaterFootprint.subtitle",
                "W tej sekcji wpisz wszystkie zabiegi związane z nawadnianiem uprawy. Możesz dodać wiele wpisów z różnymi metodami nawadniania i źródłami wody."
              )}
            </p>
          </>
        }
      >
        <IrrigationWaterFootprintForm />
        <CftReportProgress type="waterFootprint" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <IrrigationWaterFootprintFormContext>
      <IrrigationWaterFootprintPage />
    </IrrigationWaterFootprintFormContext>
  );
};
